import { render } from "./Search.vue?vue&type=template&id=37aacd70&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=37aacd70&lang=scss"
import "./Search.vue?vue&type=style&index=1&id=37aacd70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37aacd70"

export default script